export default "__VITE_ASSET__B1R03CM9__"